import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { IUserSetting, UserSetting } from './UserSetting'

export class UserSettingMapper implements ICollectionMapper<UserSetting> {
  map(data: IUserSetting): UserSetting {
    const userSetting = new UserSetting(data.userId)
    userSetting.id = data.id
    userSetting.userId = data.userId
    userSetting.eodNotificationSettings = data.eodNotificationSettings

    return userSetting
  }

  serialize(object: UserSetting): IUserSetting {
    return JSON.parse(JSON.stringify(object))
  }
}
